import { Spinner } from "react-bootstrap";

interface Props {
    show?: boolean;
    borderRadius?: string;
}

const ReactQuillSpinner = ({ show, borderRadius }: Props) => {
    if (!show) return null;

    return (
        <div
            className="position-absolute top-0 start-0 w-100 h-100 block-spinner-container"
            style={{
            borderRadius,
            zIndex: 99,
            background: "rgba(255, 255, 255, 0.6)",
            cursor: "not-allowed",
            pointerEvents: "all", // блокує кліки
            }}>
            <div className="w-100 h-100 d-flex">
            <Spinner className="m-auto" variant="primary" />
            </div>
        </div>
    );
};

    export default ReactQuillSpinner;
